// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// import { handleUnauthorized } from '../../TokenAuth/auth';


// export const fetchRechargeReport = createAsyncThunk(
//   "CallAndChatReducer/fetchRechargeReport",
//   async ({ page, limit }, { rejectWithValue }) => {
//     try {
//       const token = localStorage.getItem("vedhvidhi-admin-token");

//       const response = await axios.get(
//         `${process.env.REACT_APP_BASEURL}/admin/rechargeReport`,
//         {
//           params: { page, limit },
//           headers: {
//             Authorization: `${token}`,
//           },
//         }
//       );
//          if (response.status === 401) {
//         handleUnauthorized();
//         throw new Error("Unauthorized: Please login again");
//       }

//       return response.data; 
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Something went wrong");
//     }
//   }
// );

// // Initial state
// const initialState = {
//   data: [],
//   totalCount: 0,
//   status: "idle",
//   error: null,
//   paginationDetail: {
//     currentPage: 1,
//     perPage: 10,
//     totalPages: 0,
//     totalRecords: 0,
//   },
// };

// // Slice
// const CallAndChatReducer = createSlice({
//   name: "CallAndChatReducer",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchRechargeReport.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(fetchRechargeReport.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.data = action.payload.data;
//         state.totalCount = action.payload.totalCount;
//         state.paginationDetail = action.payload.paginationDetail; 
//         state.error = null;
//       })
//       .addCase(fetchRechargeReport.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       });
//   },
// });

// export default CallAndChatReducer.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { handleUnauthorized } from '../../TokenAuth/auth';

export const fetchRechargeReport = createAsyncThunk(
  "CallAndChatReducer/fetchRechargeReport",
  async ({ page, limit, paymentStatus = "success", search = "", startDate = "", endDate = "" }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");

      // Build params object - only include page/limit if provided, always include startDate/endDate if provided
      const params = { paymentStatus, search };
      
      if (page !== undefined && limit !== undefined) {
        params.page = page;
        params.limit = limit;
      }
      
      if (startDate) {
        params.startDate = startDate;
      }
      
      if (endDate) {
        params.endDate = endDate;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/rechargeReport`,
        {
          params: params,
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error("Unauthorized: Please login again");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

export const exportRechargeReport = createAsyncThunk(
  "CallAndChatReducer/exportRechargeReport",
  async ({ paymentStatus = "success", search = "", startDate = "", endDate = "" }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/rechargeReport`,
        {
          params: { paymentStatus, search, startDate, endDate },
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error("Unauthorized: Please login again");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

// Initial state
const initialState = {
  data: [],
  totalCount: 0,
  status: "idle",
  error: null,
  paginationDetail: {
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    totalRecords: 0,
  },
};

// Slice
const CallAndChatReducer = createSlice({
  name: "CallAndChatReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRechargeReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRechargeReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.paginationDetail = action.payload.paginationDetail;
        state.error = null;
      })
      .addCase(fetchRechargeReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(exportRechargeReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(exportRechargeReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(exportRechargeReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default CallAndChatReducer.reducer;

